module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0084.jpg?v=08d440c4";